module.exports = __webpack_public_path__ + "media/images/fr/approve-b5fdddd1935f30db4aca54c6c4321554.png";